<template>
  <!-- 检验报告  -->
  <div :style="{height: (model.isPage ? '620mm': '310mm')}" v-if="model && model.lisReport.pageDatas && model.lisReport.pageDatas.length>0">
    <div id="print_lisReport" class="lisReport-page">
      <div class="page" v-for="(pageItem, pageIndex) in model.lisReport.pageDatas">
        <div style="display: flex;font-size: 23px;text-align: center;font-weight: 600;">
          <!--
          <div style="display: table-cell; width: 90%;text-align: center;letter-spacing: 5px;">
            <div>{{ model.lisReport.hospitalName ? model.lisReport.hospitalName : ""}}</div>
            <div>{{ model.lisReport.reportName ? model.lisReport.reportName : "" }}</div>
          </div>
          -->
          <table style="width: 100%;border-collapse: collapse;border:none;letter-spacing: 5px;">
            <tbody>
              <tr style="width: 100%;border-collapse: collapse;border:none;">
                <td style="border-collapse: collapse;border:none;">{{ model.lisReport.hospitalName ? model.lisReport.hospitalName : ""}}</td>
              </tr>
              <tr style="width: 100%;border-collapse: collapse;border:none;">
                <td style="border-collapse: collapse;border:none;">{{ model.lisReport.reportName ? model.lisReport.reportName : "" }}</td>
              </tr>
            </tbody>
          </table>
          <div>
            <div>
<!--              <canvas :class="'barcode_' + model.lisReport.barCode" style="width: 100%; height: 100%;"/>-->
              <img :src="model.lisReport.barCodeImage" style="width: 100%; height: 100%;"/>
            </div>
            <div style="line-height: 0px;font-size: 15px;letter-spacing: 0px;" v-if="model.lisReport.barCodeImage">{{model.lisReport.barCode}}</div>
          </div>
        </div>

        <table style="text-align: left;width: 100%;border-collapse: collapse;border:none;margin-top:10px;border-bottom:2px solid rgb(14, 14, 14);">
          <tbody>
            <tr style="line-height: 25px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
              <td style="width: 100px;border-collapse: collapse;border:none;">姓名：{{ model.lisReport.name ? model.lisReport.name : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">性别：{{ model.lisReport.sex ? model.lisReport.sex : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">年龄：{{ model.lisReport.age ? model.lisReport.age : "" }}</td>
              <td style="border-collapse: collapse;border:none;width: 125px;">送检时间：{{ model.lisReport.sendTime ? model.lisReport.sendTime : "" }}</td>
            </tr>
            <tr style="line-height: 25px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
              <td colspan="2" style="width: 100px;border-collapse: collapse;border:none;">学校：{{ model.lisReport.schoolName ? model.lisReport.schoolName : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">年级：{{ model.lisReport.gradeName ? model.lisReport.gradeName : "" }}</td>
              <td style="width: 100px;border-collapse: collapse;border:none;">班级：{{ model.lisReport.className ? model.lisReport.className : "" }}</td>
            </tr>
          </tbody>
        </table>

        <table style="text-align: left;margin-top: 10px;width: 100%;border-collapse: collapse;border:none;border-bottom:2px solid rgb(14, 14, 14);"
               v-for="(groupItem, groupIndex) in pageItem.lisProjectGroups" v-if="pageItem.lisProjectGroups&&pageItem.lisProjectGroups.length>0">
          <tbody>
            <tr style="font-size:18px;border-collapse: collapse;text-align: center;border:none;border-bottom:1px solid rgb(14, 14, 14);font-weight: 600;">
              <td colspan="5" style="border-collapse: collapse;border:none;">{{ groupItem.groupName ? "【" + groupItem.groupName + "】" : ""}}</td>
            </tr>
            <tr class="item-title" style="line-height: 20px;border:none;background-color: #ddd;font-weight: 600;">
              <td style="width: 35%;border-collapse: collapse;border:none;">项目明细</td>
              <td style="width: 10%;border-collapse: collapse;border:none;">结果</td>
              <td style="width: 10%;border-collapse: collapse;border:none;">单位</td>
              <td style="width: 10%;border-collapse: collapse;border:none;">提示</td>
              <td style="border-collapse: collapse;border:none;">参考范围</td>
            </tr>
            <tr :class="childrenIndex % 2 === 0?'':'tr-background'" :style="{'line-height':'20px','border':'none','background-color':(childrenIndex % 2 === 0?'':'rgba(166, 161, 161, 0.12)')}"
                v-for="(childrenItem, childrenIndex) in groupItem.children">
              <td style="width: 35%;border-collapse: collapse;border:none;">{{ childrenItem.itemName }}</td>
              <td style="width: 10%;border-collapse: collapse;border:none;">{{ childrenItem.itemValue }}</td>
              <td style="width: 10%;border-collapse: collapse;border:none;">{{ childrenItem.unit }}</td>
              <td style="width: 10%;border-collapse: collapse;border:none;">{{ childrenItem.notice }}</td>
              <td style="border-collapse: collapse;border:none;">{{ childrenItem.ranges }}</td>
            </tr>
            <tr style="height: 10px;border-collapse: collapse;border:none;"></tr>
            <tr style="border:none;border-top:1px dashed rgb(14, 14, 14);">
              <td style="border-collapse: collapse;border:none;">检验人:{{ groupItem.submitter }}</td>
              <td colspan="3" style="border-collapse: collapse;border:none;">审核人:{{ groupItem.auditor }}</td>
              <td style="border-collapse: collapse;border:none;">报告时间:{{ groupItem.recordTime }}</td>
            </tr>
          </tbody>
        </table>

        <table style="width: 100%;border-collapse: collapse;border:none;text-align: center;">
          <tbody>
            <tr style="border:none;"><td style="text-indent: 2ch;border-collapse: collapse;border:none;">- 此报告结果仅对本次送检样本负责，结果仅供以上参考 -</td></tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>
<script>

import {_lisReport} from "@/services/report/report";
export default {
  name: "lisReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    isQuery: {
      type: Boolean,
      default: false
    },
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      showBarCode:false,
      model: {
        lisReport:{

        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'lisReport'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'lisReport') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.lisReport(this.barCode);
      }
    },
    lisReport(barCode) {
      _lisReport({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        /*this.$nextTick(() => {
          this.generateBarcode(this.model.lisReport.barCode);
          // this.drawBase64ToCanvas(this.model.lisReport.barCode, this.model.lisReport.barCodeImage);
        });*/
      })
    },
    generateBarcode(barCode) {
      this.showBarCode = false;
      const canvases = document.querySelectorAll('.barcode_' + barCode);
      canvases.forEach(canvas => {
        //canvas.style.cssText = "width: 114px; height: 65px;";
        JsBarcode(canvas, barCode, {
          format: "CODE128",      // 条码类型
          height: 45,             // 条码高度
          width: 1.3,             // 单条宽度
          displayValue: true,     // 显示下方文本
          text: barCode,          // 自定义文本（与条码值一致）
          fontSize: 15,           // 文本大小
          textAlign: "center",    // 文本居中
          fontOptions: "bold",	// 粗体
          font: "Arial",          // 字体类型
        });
      });
    },
    drawBase64ToCanvas (barCode, base64String) {
      this.showBarCode = true;
      const codeElements = document.getElementsByClassName('code');
      for (let i = 0; i < codeElements.length; i++) {
        codeElements[i].style.cssText = "width: 114px; height: 45px;";
      }

      const canvases = document.querySelectorAll('.barcode_' + barCode);
      canvases.forEach(canvas => {
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
          // 设置Canvas尺寸与图片一致
          canvas.width = img.width;
          canvas.height = img.height;
          // 绘制图片
          ctx.drawImage(img, 0, 0);
        };

        img.onerror = () => console.error("图片加载失败");
        img.src = base64String;
      });
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .lisReport-page {
    page: lisReport-page; /* 绑定唯一命名 */
  }
  @page lisReport-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .item-title{
    background-color: #ddd !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact; /* 标准属性，确保背景色打印 */
  }
  .tr-background{
    background-color: rgba(166, 161, 161, 0.12) !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact; /* 标准属性，确保背景色打印 */
  }
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:25px;padding-left:20px;padding-right:20px;font-size: 13px;margin-bottom:10px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
